module.exports = __webpack_public_path__ + "img/unauthorized.ae9d4024.png";